// STUB — Noop Firestore methods until GraphQL/Remi API replacement is ready.
// TODO: Replace with GraphQL hook.

export const useFirestore = (_collectionName: string) => ({
  getCount: async (_constraints?: unknown[]): Promise<number> => 0,
  getAll: async (_constraints?: unknown[]): Promise<unknown[]> => [],
  getOne: async (_id: string): Promise<unknown | null> => null,
  add: async (_data: unknown): Promise<string> => {
    throw new Error('Not implemented — pending GraphQL migration');
  },
  update: async (_id: string, _data: unknown): Promise<void> => {
    throw new Error('Not implemented — pending GraphQL migration');
  },
  delete: async (_id: string): Promise<void> => {
    throw new Error('Not implemented — pending GraphQL migration');
  },
  queryByField: async (
    _field: string,
    _values: unknown[],
    _operator?: string
  ): Promise<unknown[]> => [],
});
